import React from 'react';
import {Route, Switch} from 'react-router-dom';
import NavBar from '../Components/Nav';
import Footer from '../Components/Footer';
import Pulse from '../Components/ButtonWhatsApp';
import './layout.scss';

export default function Layout(props) {
    const {routes} = props;
    return (
      <div>
       <NavBar/>
        <LoadRoutes routes={routes}/>   
        <Pulse/>
       <Footer/> 
      </div>
    )
  }
  
  
  function LoadRoutes({ routes }) {
    return ( 
    <Switch> {
            routes.map((route, index) => (
                 <Route key = { index }
                 path = { route.path }
                 exact = { route.exact }
                 component = { route.component }
                />
            ))
        } 
        </Switch>
    );
  
  }